import { Beat, IdentifiableOption, SoundKit } from "@/models/models";
import React from "react";
import KitArt from "../arts/kit-art";
import TrackArt from "../arts/track-art";
import { tabs } from "./tabs";
import Icon from "../icons/icon";
import BaseSkeleton from "../base-skeleton";
import ArrowRight from "../icons/lib/arrow-right";

export type ArtistCollectionsMobileProps = {
  visible: boolean;
  beats?: Beat[] | null;
  songs?: Beat[] | null;
  soundkits?: SoundKit[] | null;
  beatsCount?: number | null;
  songsCount?: number | null;
  soundkitsCount?: number | null;
  isBeatsLoading?: boolean | null;
  isSongsLoading?: boolean | null;
  isSoundkitsLoading?: boolean | null;
  onTabClick?: (tab: IdentifiableOption) => void;
};

/**
 * Show the artist collections for a given artist. This version is for mobile
 * devices.
 */
const ArtistCollectionsMobile = ({
  visible,
  beats,
  songs,
  soundkits,
  beatsCount,
  songsCount,
  soundkitsCount,
  isBeatsLoading,
  isSongsLoading,
  isSoundkitsLoading,
  onTabClick,
}: ArtistCollectionsMobileProps) => {
  return (
    <>
      {visible && (
        <div className="lg:hidden visible flex flex-col gap-4 pb-normal mt-[50px]">
          {/* Beats */}
          {isBeatsLoading && (
            <BaseSkeleton className="w-full h-[70px] rounded-xl" />
          )}
          {(beats?.length ?? 0) > 0 && (
            <button
              id="mobile-creatorDetail-tab-beats"
              onClick={() => {
                onTabClick?.(tabs[0]);
              }}
              className="relative flex items-center h-[70px] p-2 bg-white rounded-xl"
            >
              <TrackArt
                item={beats?.at(0)! || { cover: null }}
                className="rounded-xl h-full w-[60px] mr-5"
              />
              <div className="flex flex-col items-start">
                <h6>Beats</h6>
                <p className="text-gray">{beatsCount}</p>
              </div>
              <Icon
                icon={ArrowRight}
                color="gray"
                className="absolute right-2"
                size={25}
              />
            </button>
          )}

          {/* Songs */}
          {isSongsLoading && (
            <BaseSkeleton className="w-full h-[70px] rounded-xl" />
          )}
          {(songs?.length ?? 0) > 0 && (
            <button
              id="mobile-creatorDetail-tab-songs"
              onClick={() => {
                onTabClick?.(tabs[1]);
              }}
              className="relative flex items-center h-[70px] p-2 bg-white rounded-xl"
            >
              <TrackArt
                item={songs?.at(0)! || { cover: null }}
                className="rounded-xl h-full w-[60px] mr-5"
              />
              <div className="flex flex-col items-start">
                <h6>Songs</h6>
                <p className="text-gray">{songsCount}</p>
              </div>
              <Icon
                icon={ArrowRight}
                color="gray"
                className="absolute right-2"
                size={25}
              />
            </button>
          )}

          {/* Soundkits */}
          {isSoundkitsLoading && (
            <BaseSkeleton className="w-full h-[70px] rounded-xl" />
          )}
          {(soundkits?.length ?? 0) > 0 && (
            <button
              id="mobile-creatorDetail-tab-sounds"
              onClick={() => {
                onTabClick?.(tabs[2]);
              }}
              className="relative flex items-center h-[70px] p-2 bg-white rounded-xl"
            >
              <KitArt
                item={soundkits?.at(0)! || { cover: null }}
                className="rounded-xl !w-[60px] mr-5"
              />
              <div className="flex flex-col items-start">
                <h6>Sound Kits</h6>
                <p className="text-gray">{soundkitsCount}</p>
              </div>
              <Icon
                icon={ArrowRight}
                color="gray"
                className="absolute right-2"
                size={25}
              />
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default ArtistCollectionsMobile;
